export function maskSsn(ssn: string): string {
  return '***-**-' + ssn.slice(5)
}

export const formatSsn = (ssn: string): string => {
  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`
}
